import React, { useState, useEffect } from 'react';
import { Container, Box, Typography } from '@mui/material';
import MovieGrid from '../components/Movies/MovieGrid';
import Loading from '../components/Common/Loading';
import api from '../services/api';

const Home = () => {
  const [movies, setMovies] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchMovies();
  }, [currentPage]);

  const fetchMovies = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `/movies/sorted?sortBy=rating&order=desc&page=${currentPage}&limit=12`
      );
      setMovies(response.data.data);
      setPagination(response.data.pagination);
      setLoading(false);
    } catch (err) {
      console.error('Failed to fetch movies:', err);
      setLoading(false);
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) return <Loading message="Loading movies..." />;

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        pt: 12,
        background: 'transparent', // Remove any background
      }}
    >
      <Container 
        maxWidth="xl" 
        sx={{ 
          pb: 8,
          background: 'transparent', // Ensure container is transparent
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 4,
            px: 2,
          }}
        >
          <Typography variant="h4" fontWeight={700}>
            {pagination.total ? `${pagination.total} Movies Available` : 'Featured Movies'}
          </Typography>
          {pagination.page && pagination.pages && (
            <Typography variant="body2" color="text.secondary">
              Page {pagination.page} of {pagination.pages}
            </Typography>
          )}
        </Box>

        <MovieGrid
          movies={movies}
          pagination={pagination}
          onPageChange={handlePageChange}
        />
      </Container>
    </Box>
  );
};

export default Home;
